import {Animated} from 'react-native';

import {useLazyValue} from 'hooks/Hooks';

export default function useAnimatedValue(initialValue: number): Animated.Value {
  return useLazyValue(() => new Animated.Value(initialValue));
}
